import React from "react";
import { ShareButton } from "../../atoms/form/button/share";
import { FaFacebookF } from "react-icons/fa";
import styled from "styled-components";
import { trackClipSocialShare, trackCreatorCardShare } from "./utils";

const StyledShare = styled(FaFacebookF)`
  color: #f8fcfd;
`;

export default function FacebookShare({ link, clip, card, ...props }) {
  const EncodedURI = encodeURI(link);

  return (
    <>
      <ShareButton
        title="Share to Facebook"
        justifyContent={"center"}
        alignItems="center"
        flex={true}
        display="flex"
        href={`https://www.facebook.com/dialog/share?app_id=595195531196882&display=popup&href=${EncodedURI}&redirect_uri=${EncodedURI}`}
        target="_blank"
        onClick={() => {
          if (clip) {
            trackClipSocialShare({
              platform: "Facebook",
              isMontage: clip.isMontage,
              clip,
            });
          } else if (card) {
            trackCreatorCardShare(card);
          }
        }}
        {...props}
      >
        <StyledShare size={24}></StyledShare>

        {props.children}
      </ShareButton>
    </>
  );
}
